import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItem } from 'src/app/modules/shared/models/project/project-section-item.model';
import { User } from 'src/app/modules/shared/models/staff/user.model';
import {
  EventService,
  EventType,
} from 'src/app/modules/shared/providers/event.service';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OmMenuService } from 'src/app/modules/shared/services/om-menu.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import {
  OrganizationType,
  OrganizationTypeMap,
} from './../../../shared/models/staff/organization-type.enum';

import { zip } from 'rxjs';
import { LoginInfo } from 'src/app/modules/shared/models/login/login-info.model';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OmUserPersonService } from 'src/app/modules/shared/services/om-user-person.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { StaffUserService } from 'src/app/modules/shared/services/staff-user.service';
import { WorkFlowTaskService } from 'src/app/modules/shared/services/work-flow-task.service';
import { Md5 } from 'ts-md5';
import { NzMessageService } from 'ng-zorro-antd/message';
import { OrganizationProjectSection } from 'src/app/modules/shared/models/staff/organization-project-section.model';

@Component({
  selector: 'open-home',
  templateUrl: './open-home.component.html',
  styleUrls: ['./open-home.component.scss'],
})
export class OpenHomeComponent {
  OrganizationTypeMap = OrganizationTypeMap;

  isLogin = false;

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private events: EventService,
    private omMenuService: OmMenuService,
    private projectSectionItemService: ProjectSectionItemService,
    private staffUserService: StaffUserService,
    private workFlowTaskService: WorkFlowTaskService,
    private projectSectionService: ProjectSectionService,
    private omUserPersonService: OmUserPersonService,
    private message: NzMessageService,
  ) {}

  private getUserInfo(info: LoginInfo) {
    zip(
      this.staffUserService.findById(info.uid!),
      this.projectSectionService.findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      }),
    ).subscribe((responses: [User, ProjectSection[]]) => {
      const user = responses[0];
      this.globalService.hasBeam = false;

      const sectionIds: number[] = [];
      if (user.userPosts && user.userPosts.length > 0) {
        // this.postInfo = user.userPosts?.[0];
        for (const post of user.userPosts ?? []) {
          if (user.organizationType === OrganizationType.CONSTRUCTION) {
            if (post.postName?.includes('梁场')) {
              this.globalService.hasBeam = true;
            }
          }
          if (!sectionIds.includes(post.sectionId!)) {
            sectionIds.push(post.sectionId!);
          }
        }
      }

      for (const section of user.projectSections ?? []) {
        if (section.beamYardSectionTag && this.globalService.hasBeam) {
          sectionIds.push(section.sectionId!);
        }
      }

      const refSectionIds: number[] = [...sectionIds];

      const sectionMap: { [key: string]: ProjectSection } = {};
      for (const section of responses[1]) {
        sectionMap[section.id!] = section;
        if (sectionIds.includes(section.id!)) {
          for (const refSection of section.projectSectionSections ?? []) {
            if (!refSectionIds.includes(refSection.refSectionId!)) {
              refSectionIds.push(refSection.refSectionId!);
            }
          }
        }
      }

      if (user.organizationType === OrganizationType.SUPERVISE) {
        const sections = responses[1].filter((item) =>
          refSectionIds.includes(item.id!),
        );
        user.projectSections = sections.map((item) => {
          const section = new OrganizationProjectSection();
          section.sectionId = item.id!;
          section.sectionName = item.name;
          section.stage = item.stage;
          section.refSectionIds = item.projectSectionSections?.map(
            (refSection) => refSection.refSectionId!,
          );
          section.sectionType = item.type;
          return section;
        });

        // user.projectSections = user.projectSections?.filter((item) =>
        //   refSectionIds.includes(item.sectionId!),
        // );
      }

      for (const section of user.projectSections ?? []) {
        if (sectionMap[section.sectionId!]) {
          section.stage = sectionMap[section.sectionId!].stage;
        }
      }

      this.globalService.userInfo = user;
      this.globalService.login(info);
      this.isLogin = true;
    });
  }

  ngOnInit() {
    const query = window.location.href.split('?')[1] ?? '';
    this.loginWithoutPassword(query);
  }

  loginWithoutPassword(query: string): void {
    const params = new URLSearchParams(query);
    console.log('token', params.get('token'));
    if (!params.get('token')) {
      this.message.error('没有检测到Token，请检查路径后进行跳转');
      return;
    }

    if (
      this.globalService.outerToken !== params.get('token') ||
      !this.globalService.token
    ) {
      this.omUserPersonService
        .loginWithoutPwd(params.get('token') ?? '')
        .subscribe((loginOutInfo: LoginInfo) => {
          this.globalService.outerToken = params.get('token') ?? '';
          this.globalService.token = loginOutInfo.token ?? '';
          this.getUserInfo(loginOutInfo);
          this.prepareWbsTree();
        });
    } else {
      this.isLogin = true;
      this.prepareWbsTree();
    }
  }

  resetSearchConfig(url: string) {
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
      window.open(url, '_blank');
      return;
    }
    this.globalService.resetSearchConfig();
  }

  private prepareWbsTree() {
    this.projectSectionItemService
      .tree({
        projectId: this.globalService.projectId,
        type: ProjectItemType.SECTION,
      })
      .subscribe((response: ProjectSectionItem) => {
        const newVer = Md5.hashStr(JSON.stringify(response));
        if (this.globalService.wbsTreeRootVersion !== newVer) {
          this.globalService.wbsTreeRootVersion = newVer;
          this.globalService.setWbsTreeRoot(response);
          this.events.broadcast(EventType.WbsChangeEvent);
        }
        this.projectSectionItemService
          .tree({
            projectId: this.globalService.projectId,
            type: ProjectItemType.FX,
          })
          .subscribe((response: ProjectSectionItem) => {
            const newVer = Md5.hashStr(JSON.stringify(response));
            if (this.globalService.wbsTitleTreeVersion !== newVer) {
              this.globalService.wbsTitleTreeVersion = newVer;
              this.globalService.setWbsTitleTree(response);
              this.events.broadcast(EventType.WbsTitleChangeEvent);
            }
          });
      });
  }
}
